<template>
  <fieldset>
    <legend>{{title}}</legend>
    <slot></slot>
  </fieldset>
</template>
<script>
export default {
  name: "qfui-kuangkuang",
  props: {
    title: {
      type: String,
      required: true
    }
  }
};
</script>
<style scoped>
</style>